module.exports = __webpack_public_path__ + "static/media/bg-atas.e092fcab.png";